export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-05.9c645b88.svg";